import React, {useState} from "react";
import { Box } from "@mui/joy";
import { useTranslation } from 'react-i18next';
import { useFormatter } from "src/mtska-frontend-app-component/utils";
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { Text } from "../Typography";
import { Button } from "../Button";
import { Confirm } from "../Dialog";

const dataProviderName = 'calendars/carcalendarrecord';
const wizardAction = 'destroy';

const BookingAvatar = ({ booking = null, loadAll }) => {

    const { formatDate } = useFormatter();
    const { t } = useTranslation();
    const { doAction } = useDataProvider(dataProviderName);

    const [confirmDelete, setConfirmDelete] = useState();
    const handleDelete = () => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Proceed")}
                okcallable={async () => {
                    doAction && await doAction({ action: wizardAction, model: dataProviderName, data: [booking._id] });
                    setConfirmDelete(null);
                    loadAll();
                }}
                kolabel={t("No")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Booking cancellation")}>
                {t("Are you sure to cancel your active booking?")}
            </Confirm>
        );
    }

    return (
        <Box className="booking-avatar">
            {/* { <textarea>{JSON.stringify(booking)}</textarea> } */}
            <Text className="label">{t('plate')}</Text>
            <Text className="value">{booking?.carCalendar?.car?.plate}</Text>
            <Text className="label">{t('vehicle')}</Text>
            <Text className="value">{booking?.carCalendar?.car?.searchable.replace(booking?.carCalendar?.car?.plate, '').trim()}</Text>
            <Text className="label">{t('bookingStart_at')}</Text>
            <Text className="value">{formatDate(booking?.bookingStart_at)}</Text>
            <Text className="label">{t('bookingEnd_at')}</Text>
            <Text className="value">{formatDate(booking?.bookingEnd_at)}</Text>
            
            <Text className="label">{t('booked_at')}</Text>
            <Text className="value">{formatDate(booking?.created_at)}</Text>


            <Box className="action">
                <Button class="buttonized input-button small MuiButton-variantSolid" onClick={handleDelete}>{t('cancel booking')}</Button>
            </Box>
            {confirmDelete}
        </Box>
    )
}

export default BookingAvatar;